import { render, staticRenderFns } from "./AlarmFlicker.vue?vue&type=template&id=5b70fdb0&scoped=true"
import script from "./AlarmFlicker.vue?vue&type=script&lang=js"
export * from "./AlarmFlicker.vue?vue&type=script&lang=js"
import style0 from "./AlarmFlicker.vue?vue&type=style&index=0&id=5b70fdb0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b70fdb0",
  null
  
)

export default component.exports